<template>
  <aw-carousel-v3-dynamic-aspect-ratio
    :content="content"
    :aspect-ratio-height="9"
    :aspect-ratio-width="21"
    :analytics-banner-interaction="analyticsBannerInteraction"
    :analytics-measurable="analyticsMeasurable"
    :small-font="true"
  />
</template>
<script>
  import analyticsBannerInteractionMixin from '~~/common/mixins/analyticsBannerInteractionMixin.js';
  import AwCarouselV3DynamicAspectRatio from './AwCarouselV3DynamicAspectRatio';

  export default {
    name: 'AwCarouselV3219',
    components: {
      AwCarouselV3DynamicAspectRatio,
    },
    mixins: [analyticsBannerInteractionMixin],
    props: {
      content: {
        type: Object,
        required: true,
      },
    },
  };
</script>
